// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Traffic Config API
 * traffic-config-api manages traffic configuration for the Aura platform.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface V1IpFilterTrafficTypesOrchestraTenantidDbidIngressConfigPutRequest
 */
export interface V1IpFilterTrafficTypesOrchestraTenantidDbidIngressConfigPutRequest {
  /**
   *
   * @type {string}
   * @memberof V1IpFilterTrafficTypesOrchestraTenantidDbidIngressConfigPutRequest
   */
  trafficType?: string;
}

/**
 * Check if a given object implements the V1IpFilterTrafficTypesOrchestraTenantidDbidIngressConfigPutRequest interface.
 */
export function instanceOfV1IpFilterTrafficTypesOrchestraTenantidDbidIngressConfigPutRequest(
  value: object,
): value is V1IpFilterTrafficTypesOrchestraTenantidDbidIngressConfigPutRequest {
  return true;
}

export function V1IpFilterTrafficTypesOrchestraTenantidDbidIngressConfigPutRequestFromJSON(
  json: any,
): V1IpFilterTrafficTypesOrchestraTenantidDbidIngressConfigPutRequest {
  return V1IpFilterTrafficTypesOrchestraTenantidDbidIngressConfigPutRequestFromJSONTyped(
    json,
    false,
  );
}

export function V1IpFilterTrafficTypesOrchestraTenantidDbidIngressConfigPutRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1IpFilterTrafficTypesOrchestraTenantidDbidIngressConfigPutRequest {
  if (json == null) {
    return json;
  }
  return {
    trafficType: json['trafficType'] == null ? undefined : json['trafficType'],
  };
}

export function V1IpFilterTrafficTypesOrchestraTenantidDbidIngressConfigPutRequestToJSON(
  json: any,
): V1IpFilterTrafficTypesOrchestraTenantidDbidIngressConfigPutRequest {
  return V1IpFilterTrafficTypesOrchestraTenantidDbidIngressConfigPutRequestToJSONTyped(
    json,
    false,
  );
}

export function V1IpFilterTrafficTypesOrchestraTenantidDbidIngressConfigPutRequestToJSONTyped(
  value?: V1IpFilterTrafficTypesOrchestraTenantidDbidIngressConfigPutRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    trafficType: value['trafficType'],
  };
}
